import { IndexedDBHelper } from "utils/indexeddb-helper";

export interface CachedMessage {
  id: string;
  type: "image" | "sticker" | "video" | "audio";
  data: Blob;
}

export class WhatsAppMessageStore {
  private dbHelper: IndexedDBHelper;
  private storeName = "messages";

  constructor() {
    this.dbHelper = new IndexedDBHelper("whatsapp-cached-messages", 1);
  }

  async init(): Promise<void> {
    await this.dbHelper.open([
      {
        name: this.storeName,
        keyPath: "id",
        indexes: [{ name: "type", keyPath: "type", unique: false }],
      },
    ]);
  }

  async saveMessage(message: CachedMessage): Promise<void> {
    await this.dbHelper.put(this.storeName, message);
  }

  async getMessage(id: string): Promise<CachedMessage | undefined> {
    return await this.dbHelper.get(this.storeName, id);
  }

  async getAllMessages(): Promise<CachedMessage[]> {
    return await this.dbHelper.getAll(this.storeName);
  }

  async getMessagesByType(
    type: "image" | "sticker" | "video" | "audio"
  ): Promise<CachedMessage[]> {
    // Como não temos query direta, buscar todas e filtrar
    const all = await this.getAllMessages();
    return all.filter((msg) => msg.type === type);
  }

  async deleteMessage(id: string): Promise<void> {
    await this.dbHelper.delete(this.storeName, id);
  }

  async clearAllMessages(): Promise<void> {
    await this.dbHelper.clear(this.storeName);
  }

  close(): void {
    this.dbHelper.close();
  }
}
